<template>
      <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Offerings</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <!-- <th scope="col">CUSIP</th> -->
                    <th scope="col"  class="sort text-center">ACCOUNT</th>
                    <th scope="col"  class="sort text-center">COST </th>
                    <th scope="col"  class="sort text-center">BOUGHT</th>
                    <th scope="col"  class="sort text-center">HOLDING QTY</th>
                    <th scope="col"  class="sort text-center">OFFERED QTY</th>
                    <!-- <th scope="col"  class="sort text-center">HOLDING QTY</th> -->
                    <th scope="col"  class="sort text-center">OFFERED PRICE</th>
                    <th scope="col"  class="sort text-center">SPREAD</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="customerOfferings.length == 0 && !loading">
                      <td><p class="nodata">No data available</p>
                      </td>
                  </tr>
                  <tr v-for="offer in customerOfferings" :key="offer.offerId">
                    <!-- <td>{{offer.cusipVal}}</td> -->
                    <td class="text-center text-primary">{{offer.customerAccount}}</td>
                    <td class="text-center text-success">{{offer.cost ? offer.cost.toFixed(3) : 'N/A'}}</td>
                    <td class="text-center">{{moment(offer.boughtDate).format("MM/DD/YYYY") }}</td>
                    <td class="text-center">{{offer.quantity }}</td>
                    <td class="text-center">{{offer.offerQuantity }}</td>
                    <!-- <td class="text-center text-success">{{offer.offerInventoryQuantity}}</td> -->
                    <td class="text-center">{{offer.offerPrice || 0}}</td>
                    <td class="text-center">{{(offer.offerPrice - offer.cost).toFixed(3)}}</td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>

    <script>
    import authService from "@/authService";
    import config from "@/config";


    export default {
        name: 'cusipOffering',
        components :{
            
        },
        props: ['cusipData'],
        data() {
            return {
                loading : false,
                errors: [],
                customerOfferings : [],
                totalRecords : null
            };
        },
        methods: {  
          getCustomerOfferings(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/offer/cusip-offer-list?cusipId="+this.cusipData.id,
                auth
            )
            .then(result => {
              this.customerOfferings = result.data;
              this.loading = false;
            })
          },
           getAllAccountList(){
            this.loading = true;
              const auth = {
                  headers: { 'org-token' : authService.getOrgToken() }
              };
              this.$http
              .get(
              config.baseUrlBidSide +
                  "/inventory/account-map-list",
                  auth
              )
              .then(result => {
                this.accountList = result.data;
                this.getCustomerOfferings();

              })
          }, 
           getAccountName(accountMappingId){
            let inv  = this.accountList.find(o => o.accountMappingId === accountMappingId);
            if(inv){
                return inv.customerName +'-'+inv.account 
            }
          } 
        },
        mounted(){
          this.getCustomerOfferings();
          //this.getAllAccountList()

        }
    };
    </script>